import lang from '@/lang/middleware/products/banking/current-accounts';

export const feeNote = (account, i18n) => {
  i18n.mergeLocaleMessage('en', lang.en);

  if (account.fee_note) {
    return account.fee_note;
  }
  if (account.feefree_text) {
    return account.feefree_text;
  }
  if (account.feefree) {
    return i18n.t('fees.free');
  }
  if (account.quarterly) {
    return i18n.t('fees.quarterly', [i18n.n(account.quarterly, 'currencyRound')]);
  }
  if (account.fee_monthly) {
    return i18n.t('fees.monthly', [i18n.n(account.fee_monthly, 'currencyRound')]);
  }
  let opts = {};
  const fields = ['daily_balance', 'monthly_lodgement'].map(f => {
    const v = parseInt(account[`feefree_${f}`], 10);
    if (isNaN(v)) {
      return null;
    }
    opts[f] = i18n.n(v, 'currencyRound');
    return f;
  }).filter(f => f);
  if (!fields.length) {
    return false;
  }
  return i18n.t(`fees.${account.reduced_fees ? 'reduced' : 'free'}.${fields.join('-')}`, opts);
};

export const filterAccount = (account, search, provider) => {
  if (!search || !search.usages) {
    return false;
  }
  if (provider && (account.institution.slug !== provider.slug)) {
    return false;
  }
  if (search.filtered_providers && search.filtered_providers.length > 0 && !search.filtered_providers.includes(account.institution.slug)) {
    return false;
  }
  if (search.account_type === 'sixtyplus') {
    if (account.account_type !== 'CURRENT' || !account.min_age || account.min_age < 60) {
      return false;
    }
  } else if (account.min_age && account.min_age >= 60) {
    return false;
  } else if (search.account_type === 'standard') {
    if (account.account_type !== 'CURRENT') {
      return false;
    }
  } else if (search.account_type === 'graduate') {
    if (account.account_type !== 'GRADUATE') {
      return false;
    }
  } else if (search.account_type === 'student') {
    if (account.account_type !== 'STUDENT') {
      return false;
    }
  }
  return true;
};

export const monthlyCost = (account, search) => {
  const monthlyLodgementOK = (account.feefree_monthly_lodgement && (search.monthly_lodgement > account.feefree_monthly_lodgement));
  let totalCharges = 0;
  const monthlyFee = monthlyLodgementOK ? 0 : account.fee_monthly;
  const atmWithdrawals = (Math.max(0, (search.usages.atm_withdrawal - account.free_atm_withdrawals)) * (account.tx_atm || 0));
  const atmWithdrawalsEur = Math.max(0, search.usages.atm_withdrawal_in_euros - account.free_atm_withdrawals_amount_in_euros) * (account.tx_atm_percentage * 0.01 || 0) || 0;
  const chipAndPins = Math.max(0, (search.usages.chip_and_pin * (account.fee_debit_card_amount || 0)));
  const contactlesses = Math.max(0, (search.usages.contactless * (account.fee_contactless || 0)));
  const directDebits = Math.max(0, (search.usages.direct_debit * (account.tx_dd || 0)));
  const onlineTranscations = Math.max(0, (search.usages.online_transactions * (account.tx_internet || 0)));
  const lodgements = Math.max(0, (search.usages.lodgements * (account.tx_lodgement || 0)));
  [monthlyFee, atmWithdrawals, atmWithdrawalsEur, chipAndPins, contactlesses, directDebits, onlineTranscations, lodgements].forEach(f => { totalCharges += f; });
  totalCharges = monthlyLodgementOK ? 0 : totalCharges;

  let discountAmount = 0;
  const chipAndPinsDiscount = parseFloat(account.fee_debit_card_amount) < 0 ? ((search.usages && search.usages.chip_and_pin) * parseFloat(account.fee_debit_card_amount) || 0) : 0;
  const contactlessesDiscount = parseFloat(account.fee_contactless) < 0 ? ((search.usages && search.usages.contactless) * parseFloat(account.fee_contactless) || 0) : 0;
  const directDebitsDiscount = parseFloat(account.tx_dd) < 0 ? ((search.usages && search.usages.direct_debit) * parseFloat(account.tx_dd) || 0) : 0;
  const onlineTranscationsDiscount = parseFloat(account.tx_internet) < 0 ? ((search.usages && search.usages.online_transactions) * parseFloat(account.tx_internet) || 0) : 0;
  const lodgementsDiscount = parseFloat(account.tx_lodgement) < 0 ? ((search.usages && search.usages.lodgements) * parseFloat(account.tx_lodgement) || 0) : 0;
  [chipAndPinsDiscount, contactlessesDiscount, directDebitsDiscount, onlineTranscationsDiscount, lodgementsDiscount].forEach(f => { discountAmount += f; });

  const costBeforeMin = totalCharges + discountAmount;
  const minFee = monthlyLodgementOK ? 0 : (account.min_monthly_fee || 0);

  return Math.max(minFee, costBeforeMin);
};
